import { PresenceStatus } from '../constants'
import { Appointment } from './AppointmentDataFactory'

export interface AppointmentDisplayData {
  bottomMessage: string
  cancelAction: () => void
  confirmAction: () => void
  constructionName: string
  eventDate: string
  eventTime: string
  eventAddress: string
  presenceStatus: PresenceStatus
  subtitle?: string
  title: string
}

interface CallbackFunctions {
  onPressCancelKeysDelivery: (invitationId: string, eventId: string, constructionName: string) => void
  onPressConfirmKeysDelivery: (invitationId: string, eventId: string) => void
  onPressCancelVisitation: (id: string) => void
  onPressConfirmVisitation: (id?: string) => void
}

export abstract class AppointmentDataGetter {
  public abstract getAppointmentDisplayData(appointment: Appointment): AppointmentDisplayData
}
